<template lang="pug">
    .add-files
        input(
            type="file"
            accept="image/png, image/jpeg, application/pdf"
            multiple="false"
            ref="input"
            style="display: none;"
            @change="event=>upload(event)"
        )
        div
            v-btn(
                @click="$refs.input.click()"
                outlined
            )
                slot

</template>

<script>
export default {
    methods: {
        upload(event) {
            let files = [...event.target.files];
            if (files.length) {
                this.$emit("upload", files);
            }
        }
    }
};
</script>
